<template>
  <div class="pageContent">
    <breadcrumbs></breadcrumbs>
    <div class="detail_area" v-if="curType == '新县概况'">
      <h1>踏遍山河，新县值得</h1>
      <p>
        地理位置新县位于北纬31°28'～31°46'，东经114°33'～115°12'之间。处河南省南端,大别山腹地，鄂豫皖三省六县结合部。东与商城县接壤，南、西面分别与湖北省麻城市、红安县、大悟县及本省罗山县毗邻，北与光山县缘连。京九铁路、312国道和正在建设的大(大庆)广(广州)高速公路穿境而过，东距合肥240公里，南距武汉160公里，北距郑州390公里，素有“三省通衢”、“中原南门”之称，跨长江、淮河两大流域，境域东西长61.6公里，南北宽40.7公里。水文气候新县属亚热带北部大陆性季风气候，具有亚热带过渡性特征，四季分明。年平均气温15.2℃，积温5524℃，年均降水1277.5毫米，平均日照2007.7小时，无霜期222天左右。土壤分为三个土类，七个亚类，以黄棕壤土分布最广，面积最大。山地宜林，畈田宜稻麦、油菜等农作物生长。境内有长江、淮河两大流域六大水系，流域面积1574平方公里，河网密度为0.6公里/平方公里。
      </p>
      <p>
        地形地貌新县境内层峦叠嶂，河溪纵横，有山地、丘陵、冲积河谷和堆积凹谷。平均海拔350米，相对高差951米，海拔700米以上的山峰46座，最高峰田铺乡黄毛尖海拔1011米，为大别山第三高峰，大小河流92条。大别山主脉东——西南向横贯县境中部，将全县分为地势较为倾斜的两部分，南属长江流域，北属淮河流域。自然地理特点为“八山一水一分田”。
      </p>
    </div>
    <div class="detail_area" v-html="content" v-else></div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/layout/breadcrumbs";
export default {
  data() {
    return {
      content: "",
      curType: this.$route.query.type,
    };
  },
  components: {
    breadcrumbs,
  },
  methods: {
    async queryDetailFn() {
      let params = {
        id: this.$route.query.id,
      };
      let res = await this.$http.queryDetail(params);
      if (res && res.errorNo == 1) {
        this.content = res.response.wznr;
        cosole.log(this.content)
      }
    },
  },
  mounted() {
    this.queryDetailFn();
  },
};
</script>
<style lang="less">
.detail_area {
  padding-top: 30px;
  p {
    text-indent: 2em;
    line-height: 36px;
  }
}
</style>
<style lang="less" scoped>
.detail_area {
  width: 1200px;
  margin: 0 auto 30px;
  h1 {
    font-weight: bold;
    font-size: 32px;
    height: 70px;
  }
  p {
    font-size: 14px;
    color: #7e808a;
    letter-spacing: 0.62px;
    line-height: 28px;
    margin-bottom: 10px;
    text-indent: 2em;
    text-align: left;
  }
}
</style>
